export const ProfileSVG = (props) => (
  <svg
    height={34}
    viewBox="0 0 36 34"
    width={36}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.148 32.449h17.148l-2.169-4.573-10.731-4.062v-3.547s2.156-1.791 2.801-4.158l1.455-1.266.595-3.373s-.907-.641-.932-.667c0 0 0-9.803-8.167-9.803s-8.167 9.803-8.167 9.803c-.025.026-.932.667-.932.667l.595 3.373L11.1 16.11c.645 2.367 2.801 4.158 2.801 4.158v3.547L3.17 27.876 1 32.45z"
      fill="none"
      stroke="#1d1d1b"
      strokeLinejoin="round"
      strokeWidth={1.2}
    />
  </svg>
);
